<template>
  <div class="jin-content">
    <div class="jin-main">
      <CVideoForType v-if="isType"></CVideoForType>
      <!-- <c-vip-video v-else-if="isVip"></c-vip-video> -->
      <c-video ></c-video>
      <!-- <c-list></c-list> -->
      <related-recommend></related-recommend>
    </div>
    <c-side ref="side">
      <c-trading-notice
        v-if="isTrading"
        @update="updateTradingNotice"
      ></c-trading-notice>
      <c-notice v-else></c-notice>
    </c-side>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import CVideo from './video'
import CVipVideo from './vipVideo'
import CVideoForType from './videoForType'
import CList from './list'
import CNotice from './notice'
import CTradingNotice from './TradingNotice'
import wechatShareConfig from '@/commons/wechatShareConfig'
import RelatedRecommend from '@/components/RelatedRecommend'

export default {
  name: '',
  components: {
    CVideo,
    CVipVideo,
    CList,
    CNotice,
    CTradingNotice,
    CVideoForType,
    RelatedRecommend
  },
  computed: {
    ...mapGetters([
      'user',
      'isLogin',
      'options' // 配置信息
    ]),
    isTrading () {
      return this.$route.meta.type === 'tradingNew'
    },
    isType () {
      return this.options.conflictProgram === this.$route.meta.type
    },
    isVip () {
      return this.$route.meta.type === 'vip'
    }
  },
  data () {
    return {}
  },
  mounted () {
    // desc

    let title = ''
    let desc = ''
    if (
      this.options &&
      this.$route.meta.type &&
      this.options[this.$route.meta.type]
    ) {
      title = this.options[this.$route.meta.type].title || document.title
      desc = this.options[this.$route.meta.type].desc
      document.title = title// + (desc ? `。` + desc : '');

      document.body.classList.add(`is-${this.$route.meta.type}`)
      document.body.setAttribute('data-title', title)
      document.body.setAttribute('data-desc', desc)
      if (window._modifyAppShareUrl) {
        window._modifyAppShareUrl({
          title: title,
          subTitle: desc,
          url: window.location.href,
          icon: 'https://cdn.jin10.com/assets/img/commons/app-logo.png'
        })
      }
    }
    // console.log(title,desc);
    wechatShareConfig({
      title: document.title,
      desc: desc,
      imgUrl: 'https://cdn.jin10.com/assets/img/commons/app-logo.png'
    })
  },
  methods: {
    updateTradingNotice () {}
  }
}
</script>



// WEBPACK FOOTER //
// main.vue?2b396c04